import { CustomPlugin } from '@slardar/sdk-web';
export var CUSTOM_INTEGRATION_NAME = 'custom';
export var customPlugin = function () { return ({
    name: CUSTOM_INTEGRATION_NAME,
    setup: function (client) {
        CustomPlugin(client);
    },
}); };
//# sourceMappingURL=custom.js.map